//External
import React, { useEffect, useState } from "react";
import dynamic from "next/dynamic";
import { capitalizeFirstLetter, get_cookie } from "utils";
import KlaviyoOffer from "components/KlaviyoOffer/Index";

//Internal
const Contactus = dynamic(() => import("../contactus"), {
  ssr: false,
});
const DynamicGoogleMap = dynamic(() => import("./googleMap"), {
  ssr: false,
});
/*******************
  @Purpose :  used for get Address
  @Parameter : { addressInfo,currentLocationId}
  @Author : INIC
 *******************/
const AddressGetInTouch = ({ addressInfo, currentLocationId }) => {
  const [mapObjValue, setMapObjValue] = useState("");
  const [cityName, setCityName] = useState("");

  const mapObj = [
    "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d826.2277842250319!2d-118.40284746760409!3d34.0717921666901!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x9e7029521f9bd9e7!2sFalcon%20Car%20Rental!5e0!3m2!1sen!2sin!4v1669269926798!5m2!1sen!2sin",
    "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d14370.869759317638!2d-80.140494!3d25.779895!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x430c1be73be4f4c0!2sFalcon%20Car%20Rental%20Miami!5e0!3m2!1sen!2sin!4v1669270184220!5m2!1sen!2sin",
  ];

  useEffect(() => {
    let tempCityName = "";
    if (get_cookie("cityStateSlug")) {
      const value = get_cookie("cityStateSlug");
      const arr = value.split("_");
      if (arr[0] != "la") {
        tempCityName = arr[0];
        setMapObjValue(mapObj["1"]);
      } else {
        setMapObjValue(mapObj["0"]);
      }
    }
    setCityName(tempCityName);
  }, [get_cookie("cityStateSlug")]);

  const [telNoStr, setTelNoStr] = useState("");
  const [companyPhoneNo, setCompanyPhoneNo] = useState("");

  useEffect(() => {
    setTimeout(() => {
      setTelNoStr("tel:" + addressInfo?.company_phone);
      setCompanyPhoneNo(addressInfo?.company_phone);
    }, 3000);
  }, [addressInfo]);

  /*******************
  @purpose : Render HTML/ React Components
  @Author : INIC
  ******************/
  return (
    <>
      {/* Section Divider  */}
      <section className="contact-us contact-home py-75">
        <div className="custom-container">
          <div className="row">
            <div className="col-lg-7 order-1 order-md-0 mt-0 mt-sm-4 mt-md-0">
              <div className="dth-mg">
                <div className="thick-devide dth-mg-child"></div>
              </div>
              <div className="section-heading">
                <h2 className="mb-0 text-black">
                  Falcon Car Rental{" "}
                  {cityName ? " " + capitalizeFirstLetter(cityName) : ""}
                </h2>
              </div>

              <ul className="list-unstyled contact-list">
                {/* {companyPhoneNo && (
                  <li>
                    <a
                      href={telNoStr}
                      className="phone-number font-22 ff-hel-reg"
                    >
                      <span className="icon icon-phone"></span>
                      {companyPhoneNo}
                    </a>
                  </li>
                )} */}

                {companyPhoneNo && (
                  <li>
                    <a
                      href={telNoStr}
                      className="phone-number font-22 ff-hel-reg"
                    >
                      <span className="icon icon-phone"></span>
                      {companyPhoneNo}
                    </a>
                  </li>
                )}

                {addressInfo["company_address"] && (
                  <li>
                    <span className="icon icon-location"></span>
                    <address className="font-22 mb-0 ff-hel-reg">
                      {addressInfo["company_address"]}
                    </address>
                  </li>
                )}

                {addressInfo["company_time_mon_fri"] && (
                  <li>
                    <span className="icon icon-clock"></span>
                    <div className="d-flex justify-content-start w-100">
                      {addressInfo["company_time_sat_sun"] && (
                        <div className="d-flex flex-column week-day">
                          <span className="font-22 ff-hel-reg">
                            Monday - Friday
                          </span>
                          <span className="muted ff-hel-reg font-24 mt-1">
                            {addressInfo["company_time_mon_fri"]}
                          </span>
                        </div>
                      )}

                      {addressInfo["company_time_sat_sun"] && (
                        <div className="d-flex flex-column week-day">
                          <span className="font-22 ff-hel-reg">
                            Saturday - Sunday
                          </span>
                          <span className="muted font-24 ff-hel-reg mt-1">
                            {addressInfo["company_time_sat_sun"]}
                          </span>
                        </div>
                      )}
                    </div>
                  </li>
                )}
              </ul>
              {/* <div className="mb-map-images">
                  <img src={googleRattingImage} alt="Google Ratting" />
                  <img src={googleReviewImage} alt="Google Review" />
                  
              </div> */}
              {/* google map code start here */}

              <DynamicGoogleMap mapObjValue={mapObjValue} />

              {/* google map code end here */}
            </div>

            <div className="col-lg-5 order-0 order-md-1">
              <div className="contact-bar">
                <KlaviyoOffer currentLocationId={currentLocationId} />
                <Contactus currentLocationId={currentLocationId} />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default AddressGetInTouch;
